import { NgxBadgeModule } from '@digipay/ngx-badge';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { Component, input, output } from '@angular/core';
import { CrowdInfoPipe } from '../../../pipes/crowd-info.pipe';
import { ProjectStatusDetailComponent } from '../../../components/project-status-detail/project-status-detail.component';
import { CrowdFundingModel } from '../../../models/crowd-funding.model';
import { BorderColorsEnum, NgxDividerComponent } from '@digipay/ngx-divider';

@Component({
  selector: 'app-crowd-list-item',
  templateUrl: './crowd-list-item.component.html',
  styleUrls: ['./crowd-list-item.component.scss'],
  standalone: true,
  imports: [CrowdInfoPipe, NgxBadgeModule, NgxButtonComponent, ProjectStatusDetailComponent, NgxDividerComponent],
})
export class CrowdListItemComponent {
  goDetail = output<void>();
  crowd = input.required<CrowdFundingModel>();
  protected readonly BorderColorsEnum = BorderColorsEnum;

  goToDetail() {
    this.goDetail.emit();
  }
}
